import { render, staticRenderFns } from "./InductionManagement.vue?vue&type=template&id=a5811156&scoped=true"
import script from "./InductionManagement.vue?vue&type=script&lang=js"
export * from "./InductionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5811156",
  null
  
)

export default component.exports